import { Route, Routes } from 'react-router-dom';
import DashboardLayout from '@/layouts/dashboard';
import AuthGuard from '@/guards/AuthGuard';
import RoleBasedGuard from '@/guards/RoleBasedGuard';

import AgentDashboard from '../pages/AgentDashboard';

export const DashboardRoutes = () => (
  <Routes>
    <Route
      element={
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      }
    >
      <Route
        index
        element={
          <RoleBasedGuard roles={['reports.view']}>
            <AgentDashboard />
          </RoleBasedGuard>
        }
      />
    </Route>
  </Routes>
);
